import { PropsWithChildren } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';

const Container = styled(Flex)<{ vertical: boolean }>`
	flex-grow: 0;
	flex-shrink: 0;
	background: ${tokens.border.subtle};
	${(props) => (props.vertical ? 'width: 1px;' : 'width: 100%; height: 1px;')}
`;

export function Separator(
	props: PropsWithChildren<BoxProps & { backgroundColor?: string; vertical?: boolean }>,
) {
	return (
		<Container
			flexGrow={0}
			flexShrink={0}
			alignItems="center"
			justifyContent="center"
			{...props}
			alignSelf={props.vertical ? 'stretch' : 'center'}
		>
			<Box px={2} backgroundColor={props.backgroundColor}>
				{props.children}
			</Box>
		</Container>
	);
}

function SeparatorInlay(props: PropsWithChildren) {
	return (
		<Flex alignItems="center">
			<Box flexGrow={1} flexShrink={1} flexBasis={0}>
				<Separator />
			</Box>
			<Box flexGrow={0} flexShrink={0} mx={2}>
				{props.children}
			</Box>
			<Box flexGrow={1} flexShrink={1} flexBasis={0}>
				<Separator />
			</Box>
		</Flex>
	);
}

Separator.Inlay = SeparatorInlay;
